function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import CaretDownIcon from "@digital-hig/icon/lib/esm/ui-controls/caret-down-small";
import CaretRight from "@digital-hig/icon/lib/esm/ui-controls/caret-right-small";
export var makeTreeViewStyles = function makeTreeViewStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiTreeView: {
      defaultProps: {
        defaultCollapseIcon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CaretDownIcon, null)),
        defaultExpandIcon: /*#__PURE__*/React.createElement(SvgIcon, null, /*#__PURE__*/React.createElement(CaretRight, null))
      },
      styleOverrides: {
        root: {
          position: "relative",
          "&.DhigTreeView--variant--flat": {
            borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"]),
            borderTop: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["detail-1-opaque"]),
            '& [class*="MuiTreeItem-root"]:first-of-type > div.DhigTreeItem': {
              hr: {
                display: "none"
              }
            },
            "& hr": {
              position: "absolute",
              left: primitives.spacings["0"],
              width: "100%",
              zIndex: 0
            }
          },
          "&.DhigTreeView--size--dense": {
            '& [class*="MuiTreeItem-content"]': {
              padding: primitives.spacings["3"]
            },
            '& [class*="MuiTreeItem-label"]': _objectSpread({}, tokens.typography["short-copy-small"])
          }
        }
      }
    }
  };
};